// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"84":"f85e3ccf7cc1d8334791","186":"1a9d62059eb77569fb5f","971":"160d1c60bbcb67d1c157"}[chunkId] + ".js";
};